import styled from 'styled-components';

import { FONTS } from '../../tokens/fonts';

export const Plank = styled.div`
    background: linear-gradient(299.06deg, #EDEDED 2.91%, #FAFAFA 86.78%);;
    width: 100%;
    height: 72px;
    min-width: 320px;
    max-width: 860px;
    position: fixed;
    display: ${props => props.isOpen ? 'flex' : 'none'};
    justify-content: flex-end;
    flex-direction: row;
    opacity: 1;
    transition: opacity 0 ease;
    flex: 1;
    z-index: 12;
`;

export const Wrapper = styled.div`
    flex-wrap: nowrap;
    display: flex;
    margin: 0 auto;
    position: fixed;
    height: inherit;
    width: 100%;
    min-width: inherit;
`;

export const CloseButton = styled.div`
    position: absolute;
    left: 10px;
    top: 21px;
    height: 22px;
    width: 22px;
    z-index: 10;
`;

export const Chest = styled.div`
    & {
        transform: rotate(45deg);
        height: 70%;
        width: 70%;
        z-index: 10;
        margin-top: 5px;
    }

    &:before,
    &:after {
        content: '';
        background-color: #1A1A1A;
        border-radius: 5px;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        transition: background-color 0.2s linear;
        height: 100%;
        width: 1px;
        z-index: 10;
    }

    &:after {
        height: 1px;
        width: 100%;
    }

    &:hover:after,
    &:hover:before {
        background-color: #ed1c24;
    }
`;

export const Text = styled.div`
    display: block;
    margin-left: 10px;
    width: 170px;
    max-height: 72px;
`;

export const Paragraph = styled.p`
    ${FONTS.XXS};
    margin: 0;
`;

export const Pic = styled.img`
    width: 42px;
    height: 42px;
    margin-left: 36px;
    margin-top: 14px;
`;

export const Header = styled.p`
    ${FONTS.S};
    margin-top: 9px;
    margin-bottom: 4px;
`;

export const Link = styled.a`
    justify-content: space-between;
    ${FONTS.MediumS};
    margin-right: 16px;
    display: flex;
    text-align: right;
    text-decoration-line: underline;
    color: #007AE5;
    z-index: +1;
`;

export const LinkContainer = styled.div`
    align-items: center;
`;
